<adapt-dialog [maxWidth]="700"
              [showHelpButton]="false">
    <h3 adapt-dialog-title>Edit role connection</h3>

    <div adapt-dialog-content>
        @if (!restoring) {
            <adapt-edit-role-connection [roleConnection]="data.roleConnection"
                                        [model]="data.model"
                                        [isAdding]="false"
                                        (roleConnectionChanged)="onRoleConnectionChanged()"
                                        (roleConnectionDeleted)="onRoleConnectionDeleted()"></adapt-edit-role-connection>
        }
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   saveButtonPreset="ok"
                                   (saveClick)="resolve(data.roleConnection)"
                                   (cancelClick)="cancel()"></adapt-standard-dialog-buttons>
</adapt-dialog>
